<template>
  <div class="enroll-manage ff-bg primary-padding">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.batchName" clearable placeholder="搜索考试名称"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="add" type="primary" style="margin-right: 0px;">
          <i class="icon icon_add"></i>
          创建报名考试
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="batchName" label="考试名称"></el-table-column>
        <el-table-column prop="enrollStartTime" label="报名开始时间">
          <template slot-scope="scope">
            {{$moment(scope.row.enrollStartTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="enrollEndTime" label="报名结束时间">
          <template slot-scope="scope">
            {{$moment(scope.row.enrollEndTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{$enums.enrollStatus[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间">
          <template slot-scope="scope">
            {{$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!--1: '待发布', 2: '已发布', 3: '已关闭'-->
            <el-button v-if="scope.row.status==1 || scope.row.status==2" size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status==3" size="mini" type="text" @click="edit(scope.row)">查看</el-button>
            <!--            <el-button v-if="scope.row.status==1" size="mini" type="text" @click="$router.push(`/batch/subject?batchId=${scope.row.batchId}`)">同步考生数据设置</el-button>-->
            <el-button v-if="scope.row.status==1" size="mini" type="text" @click="$router.push(`/musicbasis/specialty?batchId=${scope.row.batchId}`)">填写考试内容</el-button>
            <el-button v-if="scope.row.status==2" size="mini" type="text" @click="close(scope.row)">关闭</el-button>
            <el-button size="mini" type="text" @click="copy(scope.row)">复制考试</el-button>
            <el-button v-if="scope.row.status==1" size="mini" type="text" style="color: #E91212;" @click="del(scope.row)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="复制考试" v-if="editForm.show" :visible.sync="editForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="onClose()"></Edit>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Edit from './enroll-manage-editName'

export default {
  name: 'enroll-manage',
  components: { Edit },
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchName: '', batchType: 1 },
      page: {},
      editForm: { show: false, row: null, title: '复制考试' },
      taskInterval: 0,
      dialogVisible: false,
      percent: null
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {

        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiBatch.getPage(this.queryParam)
        this.page = page
        this.editForm.show = false
        this.editForm.row = null
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    add () {
      this.$router.push('./enroll-edit')
    },
    async edit (row) {
      this.$router.push(`./enroll-edit?batchId=${row.batchId}`)
    },
    async del (row) {
      try {
        let confirm = await this.$confirm('删除后将无法恢复，确定要删除该记录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiBatch.del(row.batchId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async copy (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row.batchId
      } else {
        this.editForm.row = ''
      }
    },
    async onClose (event) {
      try {
        this.editForm.show = false
        await this.getTaskInfo('copyBatchProgress' + this.editForm.row)
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            this.dialogVisible = true
            if (taskInfo.errMsg) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'error', message: taskInfo.errMsg })
              await this.getPage()
            } else if (taskInfo.percent == null) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'error', message: taskInfo.errMsg })
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async close (row) {
      try {
        let confirm = await this.$confirm('确定要关闭该考试吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiBatch.close(row.batchId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
